/* vf-banner-tabs.js - auto-advance for the VF Hero rooms section (sections/vf-banner-with-tabs.liquid).
   Switching is done by Hyper's own banner-with-tabs.js: we only click the next tab button.
   While a room is shown and the rotation runs, the root has .vf-playing (the card's yellow progress line, vf-banner-tabs.css).
   A swipe on the photo moves to the next / previous room; a tap on a room or a swipe stops the rotation, a touch only pauses it
   (so scrolling the page past the hero keeps it moving).
   Rooms after the first carry their picture addresses in data-vf-src / data-vf-srcset (sections/vf-banner-with-tabs.liquid):
   they are filled in for the shown room and the next one, when a tab is pointed at / touched / focused, and for all rooms in
   the theme editor, so only what is about to be seen is downloaded. */
(function () {
  var EVERY = 6000;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = window.Shopify && Shopify.designMode;

  function init(root) {
    if (root.vfReady) return;
    root.vfReady = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var comp = root.querySelector('banner-with-tabs');
    var nav = root.querySelector('.tabs__nav-wrap');
    if (tabs.length < 2 || !comp) return;

    function hydrate(i) {
      i = (i + tabs.length) % tabs.length;
      var els = root.querySelectorAll('[data-index="' + i + '"] [data-vf-src], [data-index="' + i + '"] [data-vf-srcset]');
      for (var n = 0; n < els.length; n++) {
        var el = els[n];
        if (el.dataset.vfSrcset) { el.srcset = el.dataset.vfSrcset; el.removeAttribute('data-vf-srcset'); }
        if (el.dataset.vfSrc) { el.src = el.dataset.vfSrc; el.removeAttribute('data-vf-src'); }
      }
    }
    if (designMode) for (var d = 0; d < tabs.length; d++) hydrate(d);
    else {
      var soon = function () { hydrate(1); };
      if (document.readyState === 'complete') setTimeout(soon, 1500);
      else window.addEventListener('load', function () { setTimeout(soon, 1500); }, { once: true });
    }
    tabs.forEach(function (tab, i) {
      ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) { tab.addEventListener(ev, function () { hydrate(i); }, { passive: true }); });
      tab.addEventListener('click', function () { hydrate(i); hydrate(i + 1); }, true);
    });

    var holds = { view: true }; // reasons to wait: view (off-screen), hover, focus, hidden, touch
    root.style.setProperty('--vf-hero-every', EVERY + 'ms');
    var stopped = false;
    var timer = 0;
    var autoClick = false;
    var last = 0;

    function current() {
      for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('aria-selected') === 'true') return i;
      return 0;
    }
    function waiting() {
      for (var k in holds) if (holds[k]) return true;
      return false;
    }
    function playing(on) {
      root.classList.remove('vf-playing');
      if (!on) return;
      void root.offsetWidth; // restart the progress line from zero
      root.classList.add('vf-playing');
    }
    function schedule() {
      clearTimeout(timer);
      var run = !(stopped || reduce.matches || designMode || waiting());
      playing(run);
      if (!run) return;
      timer = setTimeout(function () {
        autoClick = true;
        go(1);
        setTimeout(function () { autoClick = false; }, 60);
        schedule();
      }, EVERY);
    }
    function stop() {
      stopped = true;
      clearTimeout(timer);
      playing(false);
    }
    function go(step) {
      hydrate(current() + step);
      tabs[(current() + step + tabs.length) % tabs.length].click();
    }
    function hold(key, on) {
      holds[key] = on;
      schedule();
    }

    // user interaction (trusted events only) stops the carousel for good
    root.addEventListener('click', function (e) { if (e.isTrusted) stop(); }, true);
    // touch pauses; a horizontal swipe on the photo (not on the pill row, which scrolls) changes room and stops
    var t0 = null;
    root.addEventListener('touchstart', function (e) {
      hold('touch', true);
      var p = e.touches[0];
      t0 = e.target.closest('.tabs__nav-wrap') ? null : { x: p.clientX, y: p.clientY };
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var p = e.changedTouches[0];
      if (t0) {
        var dx = p.clientX - t0.x;
        var dy = p.clientY - t0.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          stop();
          var rtl = getComputedStyle(root).direction === 'rtl';
          go((dx < 0) !== rtl ? 1 : -1); // LTR: swipe left = next; RTL: swipe right = next
        }
      }
      t0 = null;
      hold('touch', false);
    }, { passive: true });
    root.addEventListener('touchcancel', function () { t0 = null; hold('touch', false); }, { passive: true });
    root.addEventListener('keydown', stop);
    // hover / focus only pause
    root.addEventListener('mouseenter', function () { hold('hover', true); });
    root.addEventListener('mouseleave', function () { hold('hover', false); });
    root.addEventListener('focusin', function () { hold('focus', true); });
    root.addEventListener('focusout', function () { hold('focus', false); });
    document.addEventListener('visibilitychange', function () { hold('hidden', document.visibilityState === 'hidden'); });
    if (reduce.addEventListener) reduce.addEventListener('change', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { hold('view', !en[0].isIntersecting); }, { threshold: 0.3 }).observe(root);
    } else {
      holds.view = false;
    }

    comp.addEventListener('tabChange', function () {
      var i = current();
      hydrate(i);
      hydrate(i + 1);
      if (i !== last) {
        last = i;
        if (window.vfTrack) window.vfTrack('hero_tab', { tab: i, auto: autoClick });
      }
      // keep the active pill visible in the swipeable mobile row
      if (nav && nav.scrollWidth > nav.clientWidth + 2) {
        var a = tabs[i].getBoundingClientRect();
        var b = nav.getBoundingClientRect();
        nav.scrollBy({ left: a.left + a.width / 2 - (b.left + b.width / 2), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      schedule();
    });
    schedule();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.banner-with-tabs.vf-banner-with-tabs'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
